import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const Container = styled.div `
  position: relative;
  width: 100%;
  max-width: var(--siteWidth);
  z-index: 1000;
`;
const Wrapper = styled.div `
  --bgColor: ${brand.grey.grey7};
  --fgColor: ${brand.white};

  top: 0;
  height: 100%;
  width: 100%;
  max-width: var(--siteWidth);
  background-color: var(--bgColor);
  color: var(--fgColor);
  border: 1px solid ${brand.grey.otherGrey};
  z-index: ${Layers.Overlays};
  pointer-events: auto;
  transition: background-color 300ms ease-in-out, color 300ms ease-in-out;

  [data-ready='true'] & {
    position: absolute;
  }

  [data-fixed='true'] & {
    --bgColor: ${brand.white};
    --fgColor: ${brand.grey.grey5};
    position: fixed;
    top: var(--headerHeight);
    left: 50%;
    transform: translateX(-50%);
    height: auto;
  }
`;
const Inner = styled.div `
  height: 100%;
  width: 100%;
  font-size: ${fluid(16, 18)};
  line-height: ${fluid(24, 30)};
  ${fonts.helvetica.bold};

  @media ${from(Device.Tablet)} {
    display: flex;
  }
`;
const Title = styled.span `
  width: 100%;
  padding: 13px 18px 11px;
  border-bottom: 1px solid ${brand.grey.otherGrey};

  @media ${from(Device.Tablet)} {
    width: auto;
    max-width: 50%;
    flex: 0 0 auto;
    padding: 19px 40px 17px;
    border-right: 1px solid ${brand.grey.otherGrey};
    border-bottom: none;
  }
`;
const Anchors = styled.div `
  position: relative;
  flex-grow: 1;
  width: auto;
  flex: 1 1 auto;
  padding: 0 18px;

  @media ${from(Device.Tablet)} {
    width: auto;
    padding: 0 40px 0 64px;
  }
`;
const ActiveAnchor = styled.div `
  position: relative;
  display: block;
  padding: 13px 32px 11px 0;
  cursor: pointer;

  @media ${from(Device.Tablet)} {
    padding: 19px 32px 17px 0;
  }
`;
const progressBarShared = css `
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
`;
const ProgressBar = styled.div `
  ${progressBarShared};
  height: 6px;
  border: 1px solid ${brand.grey.otherGrey};
`;
const ProgressBarIndicator = styled.div `
  width: 0;
  height: 100%;
  background-color: ${brand.yellow.base};
  transition: width 100ms linear;
`;
const Arrow = styled.div `
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  will-change: transform;
  transition: transform 0.3s ease;

  ${ActiveAnchor}:hover & {
    transform: translateY(-50%) translateY(5px);
  }

  ${ActiveAnchor}[data-open='true'] & {
    transform: translateY(-50%) scaleY(-1);
  }
`;
export const AnchorList = styled.div `
  position: absolute;
  left: -1px;
  bottom: 0;
  transform: translateY(100%);
  width: calc(100% + 2px);
  display: none;
  padding: 0 18px;
  background-color: var(--bgColor);
  border: 1px solid ${brand.grey.otherGrey};
  border-top-color: transparent;

  &[data-open='true'] {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  @media ${from(Device.Tablet)} {
    padding: 0 40px 0 64px;
  }
`;
export const AnchorButton = styled.a `
  width: 100%;
  background: none;
  border: none;
  padding: 19px 0 17px;
  color: var(--fgColor);
  ${fonts.helvetica.bold};
  text-align: left;
  will-change: color;
  transition: color 0.3s ease;

  &:hover {
    color: ${brand.yellow.base};
  }
`;
export const InPageNavigationStyles = {
    ActiveAnchor,
    AnchorButton,
    AnchorList,
    Anchors,
    Arrow,
    Container,
    Inner,
    ProgressBar,
    ProgressBarIndicator,
    Title,
    Wrapper,
};
